import { useState } from "react";
import { Autocomplete, TextField, Typography } from "@mui/material";
import { MRT_Row, MRT_ColumnDef } from "material-react-table";
import { Job } from "../../../../api";
import { ColumnContext } from "./ColumnHelpers";
import { columnDisplayNames } from "../../../admin/ImportSettings";
import { getValidationErrorKey, isFieldRequired } from "../../../../utilities/jobValidation";

export function column_LastCrop(context: ColumnContext): MRT_ColumnDef<Job, unknown> {
	return {
		id: "lastCrop",
		header: columnDisplayNames.lastCrop,
		accessorKey: "lastCrop",
		enableEditing: false,
		minSize: 150,
		Cell: ({ row }: { row: MRT_Row<Job> }) => {
			const validationKey = getValidationErrorKey("lastCrop", row.original.id);
			const currentValue = context.jobs.find((j) => j.id === row.original.id)?.lastCrop || null;
			const showOtherMessage = currentValue === "Other";
			const rowContext = context.getRowValidationContext(row);
			const isRequired = isFieldRequired("lastCrop", rowContext);

			return (
				<Autocomplete
					size="small"
					style={{ width: "100%", padding: 0 }}
					value={currentValue}
					options={context.props.lastCropOptions ?? []}
					renderInput={(params) => (
						<TextField
							style={{ padding: 0 }}
							{...params}
							required={isRequired}
							error={!!context.validationErrors?.[validationKey]}
							helperText={showOtherMessage ? "Put type in Submission Notes" : context.validationErrors?.[validationKey]}
						/>
					)}
					onChange={(event, newValue) => {
						const newJobs = [...context.jobs];
						const newJob = newJobs.find((j) => j.id === row.original.id);
						if (!newJob) return;
						const index = newJobs.indexOf(newJob);
						newJob.lastCrop = newValue as string | undefined;
						newJobs[index] = newJob;
						context.setJobs(newJobs);

						context.validateJobs([newJob], { updateState: true, clearPrevious: false });
					}}
					getOptionLabel={(option) => option || ""}
				/>
			);
		},
		AggregatedCell: ({ row }: { row: MRT_Row<Job> }) => {
			const [selectedValue, setSelectedValue] = useState<string | null>(null);
			return (
				<>
					<Autocomplete
						fullWidth={true}
						value={selectedValue}
						options={context.props.lastCropOptions ?? []}
						renderInput={(params) => <TextField {...params} />}
						onChange={(event, newValue) => {
							setSelectedValue(newValue);

							const newJobs = context.updateJobGroup(row, context.jobs, (job) => {
								job.lastCrop = newValue as string | undefined;
							});

							context.setJobs(newJobs);
							context.validateJobs(newJobs, { updateState: true, clearPrevious: false });
						}}
						getOptionLabel={(option) => option || ""}
					/>
					{selectedValue === "Other" && (
						<Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, fontSize: "0.75rem" }}>
							Please put the crop type in Submission Notes
						</Typography>
					)}
				</>
			);
		},
	};
}
